import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import apiurl from './apiurl';
import axios from 'axios';
import swal from 'sweetalert';
import Select from 'react-select';
import BudzetZadaniowy from './BudzetZadaniowy';




export default class DodajBudZad extends React.Component {

constructor(props) {
  super();    
  this.state = {
    rok: props.rok,
    token: props.token,
    onlyExisting: false,
    idZad: null,
    opis: null,
    wniosek: 0,
    dwbp: '2',
    isLoadingPozycja: true,
    isLoadingWydzial: true,
    isLoadingRodzaj: true,
  };
}

componentDidMount(){
  this.onListaZrodla();

  this.onListaDzial();
  this.onListaRozdzial();
  this.onListaParagraf();
  this.onListaP4();
  this.onListaPozycja();
  this.onListaWydzialy();
  this.onListaRodzaj();

}

onListaZadania = (exist) => {
  const data = this.props.dataRow;
  axios
  .get(apiurl+"api/Listy/GetZadania", { params : {
    rok : this.props.rok, 
    idUchwaly: data.id,
    dzial:  this.state.Dzial,
    rozdzial:  this.state.Rozdzial,
    paragrafp4:  this.state.Paragraf + this.state.P4,
    pozycja:  this.state.pozycja,
    dwbp: this.state.dwbp,
    idWydz:  this.state.idWydz,
    onlyExisting: exist
  }, headers: { 'Authorization' : "Bearer " + this.state.token }})
  .then(res => {
    let resdata = res.data;
    if(resdata.length > 0 ){
      let data = resdata.map( category => ({ value: category.value, label: category.text}));
      this.setState({data, idZad: data[0].value, Zadaniat: data[0].label});
    } else { this.setState({ data : [] }) }
  })
  .catch(error => swal('error'));

}

onListaZrodla = async () => {
  const res = await axios.get(apiurl+"api/Listy/GetZrodlaFin", {  headers: { 'Authorization' : "Bearer " + this.state.token }}).catch(error => this.setState({ error,  }));
  let datafin = res.data.map( category => ({ value: category.value, label: category.text}));
  this.setState({datafin, zrodlododaj: datafin[0].value, zrodlotext: datafin[0].label});
}

submitForm = (a) => {
  a.preventDefault();
  const dataRow = this.props.dataRow;

  axios.post(apiurl+"api/Zadania", {
    rok: this.state.rok, 
    idUchwaly: dataRow.id, 
    idZadania: this.state.idZad, 
    dzial: this.state.Dzial, 
    rozdzial: this.state.Rozdzial, 
    paragrafP4: this.state.Paragraf + this.state.P4,
    pozycja: this.state.pozycja === 'Inna' ? this.state.pozycjaRecznie : this.state.pozycja, 
    dwbp: this.state.dwbp, 
    idWydz: this.state.idWydz, 
    idRodz: this.state.idRodz, 
    opis: this.state.opis, 
    kwota: this.state.wniosek, 
    zrodloFin: this.state.zrodlododaj 
  }, {headers : {'Content-Type': 'application/json' , 'Authorization' : "Bearer " + this.state.token } })
  .then(res => {

  })
  .catch(error => {
    swal(error.response.data)
  });

}

// DANE DO DDL

onListaDzial = async () => {
  const res = await axios.get(apiurl+"api/Listy/GetSlownikDzialy?", { params : {rok : this.state.rok }, headers: { 'Authorization' : "Bearer " + this.state.token }}).catch(error => this.setState({ error,  }));
  let data11 = res.data.map( category => ({ value: category.value, label: category.text}));
  this.setState({data11, Dzial: data11[0].value, Dzialt: data11[0].label});
}

onListaRozdzial = async () => {
  const res = await axios.get(apiurl+"api/Listy/GetSlownikRozdzialy?", { params : {rok : this.state.rok }, headers: { 'Authorization' : "Bearer " + this.state.token }}).catch(error => this.setState({ error,  }));
  let data12 = res.data.map( category => ({ value: category.value, label: category.text}));
  this.setState({data12, Rozdzial: data12[0].value, Rozdzialt: data12[0].label});
}

onListaParagraf = async () => {
  const res = await axios.get(apiurl+"api/Listy/GetSlownikParagrafy?", { params : {rok : this.state.rok, dwprbp : this.state.dwbp }, headers: { 'Authorization' : "Bearer " + this.state.token }}).catch(error => this.setState({ error,  }));
  let data13 = res.data.map( category => ({ value: category.value, label: category.text}));
  this.setState({data13, Paragraf: data13[0].value, Paragraft: data13[0].label});
}

onListaP4 = async () => {
  const res = await axios.get(apiurl+"api/Listy/GetSlownikP4?", { params : {rok : this.state.rok }, headers: { 'Authorization' : "Bearer " + this.state.token }}).catch(error => this.setState({ error,  }));
  let data14 = res.data.map( category => ({ value: category.value, label: category.text}));
  this.setState({data14, P4: data14[0].value, P4t: data14[0].label});
}

onListaWydzialy = async () => {
  const res = await axios.get(apiurl+"api/Listy/GetWydzialy?", { params : {rok : this.state.rok }, headers: { 'Authorization' : "Bearer " + this.state.token }}).catch(error => this.setState({ error,  }));
  let data16 = res.data.map( category => ({ wydzialvalue: category.value, nazwawydzial: category.text}));
  this.setState({data16, isLoadingWydzial: false, idWydz: data16[0].wydzialvalue});
}

onListaPozycja = async () => {
  const res = await axios.get(apiurl+"api/Listy/GetSlownikPozycje?", { params : {rok : this.state.rok, dwrpbp : this.state.dwbp }, headers: { 'Authorization' : "Bearer " + this.state.token }}).catch(error => this.setState({ error,  }));
  let data15 = res.data.map( category => ({ pozycjavalue: category.value, nazwapozycja: category.text}));
  this.setState({data15, isLoadingPozycja: false, pozycja: data15[0].pozycjavalue});
}

onListaRodzaj = async () => {
  const res = await axios.get(apiurl+"api/Listy/GetSlownikRodzaje?", { params : {rok : this.state.rok }, headers: { 'Authorization' : "Bearer " + this.state.token }}).catch(error => this.setState({ error,  }));
  let data17 = res.data.map( category => ({ rodzajvalue: category.value, nazwarodzaj: category.text}));
  this.setState({data17, isLoadingRodzaj: false, idRodz: data17[0].rodzajvalue});
}



czyZmienne = () => {
  const { Dzial, Rozdzial, Paragraf, P4, pozycja, dwbp, idWydz } = this.state;

  if(Dzial && Rozdzial && Paragraf && P4 && pozycja && dwbp && idWydz) { return true }
  else { return false }
}

pobierzDzialania = () => {
  if(this.czyZmienne()){ this.onListaZadania(this.state.onlyExisting)}
  else { return null }
}


wersjaTabeli = (statId) => {
  if(Number(statId) === 0 || Number(statId) == 1 ||  Number(statId) == 2 || Number(statId) == 3 || Number(statId) === 10 || Number(statId) == 11 ||  Number(statId) == 12 || Number(statId) == 13) { return false }
  else { return true }
}

przejdzZadania = () => { 
  const wersja = this.wersjaTabeli(this.props.dataRow.statid);
  const konfig =  JSON.parse(sessionStorage.getItem("konfig")) ? JSON.parse(sessionStorage.getItem("konfig")) : [];

  ReactDOM.render(<BudzetZadaniowy 
    token={this.props.token} 
    rok={this.props.rok}
    dataRow={this.props.dataRow}
    wersjaTabeli={wersja}
    konfig={konfig}
  />, document.getElementById("root"));
}

render() {

const { data, datafin, zrodlotext, opis, wniosek, dwbp, pozycja, isLoadingPozycja, data15, isLoadingRodzaj, isLoadingWydzial,
        data11, Dzialt, data12, Rozdzialt, data13, Paragraft, data14, P4t, idRodz, data17, data16, idWydz, pozycjaRecznie
      } = this.state;

return (<>

<div className="container"> 

  <h3>Dodaj zadanie</h3>

  <hr width="75%" align="left"/>

    <form id="dodaj-zadanie" name="form-dodaj-zadania" class="form-horizontal" onSubmit={(e) => this.submitForm(e)}> 

    <div class="row">
      <div class="col-xs-4 col-sm-4 col-md-2 col-lg-2"><label class="control-label">Wybierz:</label></div>
      <div class="col-xs-7 col-sm-7 col-md-5 col-lg-5">
      <select  type="select" class="form-control" onChange={(e) => (this.setState({ dwbp: e.target.value }, this.pobierzDzialania(this.state.onlyExisting)))} name="dwbp" value={dwbp} required>
        <option key="1" defaultValue="Wybierz" hidden="hidden" >Wybierz</option>
        <option key="2" value="1" >Dochody budżetowe</option>
        <option key="3" value="2" >Wydatki budżetowe</option>
        <option key="4" value="3" >Dochody pozabudzetowe</option>
        <option key="5" value="4" >Wydatki pozabudzetowe</option>
      </select>
      </div>
    </div><br></br>

    <div class="row">
      <div class="col-xs-4 col-sm-4 col-md-2 col-lg-2"><label >Działy:</label></div>
      <div class="col-xs-7 col-sm-7 col-md-5 col-lg-5">
        <Select name="form-field-name" options={data11} placeholder={Dzialt} onChange={d => (this.setState({Dzial: d.value}, this.pobierzDzialania(this.state.onlyExisting)))} required />
      </div>
    </div> <br></br>

    <div class="row">
      <div class="col-xs-4 col-sm-4 col-md-2 col-lg-2"><label >Rozdziały:</label></div>
      <div class="col-xs-7 col-sm-7 col-md-5 col-lg-5">
        <Select name="form-field-name" options={data12} placeholder={Rozdzialt} onChange={r => this.setState({Rozdzial: r.value}, this.pobierzDzialania(this.state.onlyExisting))} required />
      </div>
    </div><br></br>

    <div class="row">
      <div class="col-xs-4 col-sm-4 col-md-2 col-lg-2"><label >Paragraf:</label></div>
      <div class="col-xs-7 col-sm-7 col-md-5 col-lg-5">
        <Select name="form-field-name" options={data13} placeholder={Paragraft} onChange={p => this.setState({Paragraf: p.value}, this.pobierzDzialania(this.state.onlyExisting))} required />
      </div>
    </div><br></br>

    <div class="row">
      <div class="col-xs-4 col-sm-4 col-md-2 col-lg-2"><label >P4:</label></div>
      <div class="col-xs-7 col-sm-7 col-md-5 col-lg-5">
        <Select name="form-field-name" options={data14} placeholder={P4t} onChange={b => this.setState({P4: b.value}, this.pobierzDzialania(this.state.onlyExisting))} required />
      </div>
    </div><br></br>

    <div class="row">
      <div class="col-xs-4 col-sm-4 col-md-2 col-lg-2"><label >Pozycja:</label></div>
      <div class="col-xs-7 col-sm-7 col-md-5 col-lg-5">
        <select type="select" class="form-control" name="pozycjavalue" value={pozycja} onChange={(e) => (this.setState({ pozycja: e.target.value }, this.pobierzDzialania(this.state.onlyExisting)))} required >
          {!isLoadingPozycja ? (
            data15.map(user15 => {
            const {pozycjavalue, nazwapozycja} = user15;
            return ( <option value={pozycjavalue} > {nazwapozycja}</option> );
            })
          ) : ( <option>Wybierz</option> )}
        </select>
      </div>
    </div><br></br>

    {this.state.pozycja === 'Inna' ? (<><div class="row">
      <div class="col-xs-4 col-sm-4 col-md-2 col-lg-2"><label >Pozycja:</label></div>
      <div class="col-xs-7 col-sm-7 col-md-5 col-lg-5">
        <input type="text" class="form-control" pattern="[0-9]{4}" value={pozycjaRecznie} placeholder="Wprowadz inną pozycje..." required title="Minimum 4 cyfry" id="pozycjavalue" name="pozycjavalue"  onChange={(e) => (this.setState({ pozycjaRecznie: e.target.value }))}></input>
      </div>
    </div><br></br></>) : null }  

    <div class="row">
      <div class="col-xs-4 col-sm-4 col-md-2 col-lg-2"><label >Rodzaj:</label></div>
      <div class="col-xs-7 col-sm-7 col-md-5 col-lg-5">
        <select type="select" class="form-control" name="rodzajvalue" value={idRodz} onChange={(e) => (this.setState({ idRodz: e.target.value }))} required >
          {!isLoadingRodzaj ? (
            data17.map(user17 => {
              const {rodzajvalue, nazwarodzaj} = user17;
              return ( <option value={rodzajvalue} > {nazwarodzaj}</option> );
            })
          ) : ( <option>Wybierz</option> )}
        </select>
      </div>
    </div><br></br>

    <div class="row">
      <div class="col-xs-4 col-sm-4 col-md-2 col-lg-2"><label >Wydział:</label></div>
      <div class="col-xs-7 col-sm-7 col-md-5 col-lg-5">
        <select type="select" class="form-control" name="wydzialvalue" value={idWydz} onChange={(e) => (this.setState({ idWydz: e.target.value }, this.pobierzDzialania(this.state.onlyExisting)))} required >
          {!isLoadingWydzial ? (
            data16.map(user16 => {
              const {wydzialvalue, nazwawydzial} = user16;
              return ( <option value={wydzialvalue}> {nazwawydzial}</option> );
            })
          ) : ( <option>Wybierz</option> )}
        </select>
      </div>
    </div><br></br>
  

{/* STARY FORM */}

      <div class="row">

          <div class="col-xs-4 col-sm-4 col-md-2 col-lg-2"><label class="control-label">Opis:</label></div>

          <div class="col-xs-6 col-sm-6 col-md-5 col-lg-5"><input type="text" class="form-control" id="opis" value={opis} name="opis" placeholder="Wpisz opis" onChange={(z) => (this.setState({ opis: z.target.value }))}></input></div>

      </div><br></br>

      <div class="row">

            <div class="col-xs-4 col-sm-4 col-md-2 col-lg-2"><label class="control-label">Wybierz działanie:</label></div>

            <div class="col-xs-6 col-sm-6 col-md-5 col-lg-5">

            <Select name="form-field-name" options={data} placeholder="Wybierz" noOptionsMessage={() => 'Brak wyników'} isDisabled={!(this.czyZmienne())} onChange={c => this.setState({idZad: c.value})}/>

            </div>

      </div><br></br>

      <div class="row">

            <div class="col-xs-4 col-sm-4 col-md-2 col-lg-2"><label class="form-check-label" for="exist">Pokaż istniejące</label></div>

            <div class="col-xs-6 col-sm-6 col-md-5 col-lg-5">

            {this.state.onlyExisting ? (<input type="checkbox" class="form-check-input ml-3" checked id="exist" onClick={() => (this.setState({ onlyExisting: false }, this.onListaZadania(false)))}></input>) : (<input type="checkbox" class="form-check-input ml-3" id="exist" onClick={() => (this.setState({ onlyExisting: true }, this.onListaZadania(true)))}></input>)}

            </div>

      </div><br></br>

      <div class="row">

              <div class="col-xs-4 col-sm-4 col-md-2 col-lg-2"><label >Wniosek:</label></div>

              <div class="col-xs-6 col-sm-6 col-md-5 col-lg-5"><input type="number" class="form-control" required title="Wpisz wniosek" value={wniosek} pattern="[0-9]+([\.,][0-9]+)?" step="0.01" id="Wniosekd" name="Wniosekd" onChange={(z) => (this.setState({ wniosek: z.target.value }))}></input></div>

      </div> <br></br>

      <div class="row">

            <div class="col-xs-4 col-sm-4 col-md-2 col-lg-2"><label class="control-label">Wybierz źródło finansowania:</label></div>

            <div class="col-xs-6 col-sm-6 col-md-5 col-lg-5">

            <Select name="form-field-name" options={datafin} placeholder={zrodlotext} onChange={c => this.setState({zrodlododaj: c.value})}/>

            </div>

      </div><br></br>

      <div class="row">

              <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"></div>

              <div class="col-xs-6 col-sm-6 col-md-5 col-lg-5">

              <button type="button" class="btn btn-light pull-left" onClick={() => (this.przejdzZadania())} >Anuluj</button>

              <button type="submit"  class="btn btn-light m-3" id="function" >Zapisz</button>

              </div>

      </div>

    </form>

  </div>


</>);

}

}

